import {FC} from 'react'
import {MultiTagFilteringFieldRow} from 'components/SearchForm/MultiTagFilteringFieldRow'

const hasDependents = [
  {name: '有', id: 'true'},
  {name: '無', id: 'false'},
]

export const HasDependents: FC = () => {
  return <MultiTagFilteringFieldRow header="家族の有無" name="hasDependents" list={hasDependents} shouldUnregister />
}
